/* Walleria Lightbox (02.10.2026): Klick/Tipp auf das grosse Galeriebild, ein „In Aktion“-Bild oder ein Community-Bild oeffnet
   eine Vollbild-Ansicht (hoechste CDN-Aufloesung width=2048, Blaettern ‹ ›, Wischen, Esc/X/Hintergrund schliesst, Zaehler,
   Alt-Text als Unterschrift, Desktop-Klick = 2x-Zoom, Handy = natives Pinch-Zoom + Doppeltipp 2x, Fokus-Falle, Fokus-Rueckkehr).
   Rein additiv: eigene Datei, keine Aenderung an wl-produkt.js. Rueckbau = Einbindung in sections/wl-produkt.liquid entfernen. */
(function(){
  "use strict";
  if(window.wlLightbox) return;
  var main=document.getElementById("wlpMain");
  var EN=(document.documentElement.lang||"de").toLowerCase().indexOf("en")===0;
  var T={schliessen:EN?"Close":"Schließen",zurueck:EN?"Previous image":"Vorheriges Bild",weiter:EN?"Next image":"Nächstes Bild",
         zoom:EN?"Zoom in or out":"Vergrößern oder verkleinern",titel:EN?"Image view":"Bildansicht",lupe:EN?"Tap to enlarge":"Zum Vergrößern tippen"};
  try{ var tj=main&&main.getAttribute("data-wl-lb-t"); if(tj){ var t2=JSON.parse(tj); for(var k in t2){ if(t2[k]) T[k]=t2[k]; } } }catch(e){}
  var reduziert=false; try{ reduziert=window.matchMedia("(prefers-reduced-motion: reduce)").matches; }catch(e){}
  var SEL_GAL="#wlpMain .wlp-slide:not(.is-vorschau) img", SEL_AKT=".wlp-akt img", SEL_WLU=".wlu-item img";
  var SEL=SEL_GAL+","+SEL_AKT+","+SEL_WLU;
  var SVG_X='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var SVG_L='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var SVG_R='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var SVG_LUPE='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }
  function $all(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }
  function gross(img){
    var g=img.getAttribute("data-wl-gross"); if(g) return g;
    var s=img.currentSrc||img.src||"";
    return /[?&]width=\d+/.test(s) ? s.replace(/([?&])width=\d+/,"$1width=2048") : s;
  }
  function gruppe(img){
    if(img.closest("#wlpMain")) return $all(SEL_GAL);
    if(img.closest(".wlp-akt")) return $all(SEL_AKT);
    if(img.closest(".wlu-item")) return $all(SEL_WLU);
    return [img];
  }

  /* ---- Lupe als Hinweis in der Ecke des grossen Bilds ---- */
  if(main && document.querySelector(SEL_GAL)){
    var lupe=document.createElement("span"); lupe.className="wl-lb-lupe"; lupe.title=T.lupe; lupe.setAttribute("aria-hidden","true"); lupe.innerHTML=SVG_LUPE; main.appendChild(lupe);
  }

  /* ---- Overlay (einmalig beim ersten Oeffnen gebaut) ---- */
  var lb=null, els={}, liste=[], idx=0, ausloeser=null, offen=false, zoom=false, ladeNr=0;
  function bauen(){
    lb=document.createElement("div"); lb.className="wl-lb"; lb.hidden=true;
    lb.setAttribute("role","dialog"); lb.setAttribute("aria-modal","true"); lb.setAttribute("aria-label",T.titel);
    lb.innerHTML='<div class="wl-lb-kopf"><span class="wl-lb-zahl" aria-live="polite"></span><button type="button" class="wl-lb-x" aria-label="'+esc(T.schliessen)+'">'+SVG_X+'</button></div>'
      +'<button type="button" class="wl-lb-pfeil l" aria-label="'+esc(T.zurueck)+'">'+SVG_L+'</button>'
      +'<button type="button" class="wl-lb-pfeil r" aria-label="'+esc(T.weiter)+'">'+SVG_R+'</button>'
      +'<div class="wl-lb-buehne"><img class="wl-lb-bild" alt="" draggable="false" tabindex="0" aria-label="'+esc(T.zoom)+'"><span class="wl-lb-lade" aria-hidden="true"></span></div>'
      +'<div class="wl-lb-fuss"></div>';
    document.body.appendChild(lb);
    els={zahl:lb.querySelector(".wl-lb-zahl"),x:lb.querySelector(".wl-lb-x"),l:lb.querySelector(".wl-lb-pfeil.l"),r:lb.querySelector(".wl-lb-pfeil.r"),
         buehne:lb.querySelector(".wl-lb-buehne"),bild:lb.querySelector(".wl-lb-bild"),fuss:lb.querySelector(".wl-lb-fuss")};
    els.x.addEventListener("click",schliessen);
    els.l.addEventListener("click",function(){ zeigen(idx-1); });
    els.r.addEventListener("click",function(){ zeigen(idx+1); });
    /* Hintergrund-Klick schliesst (nur echter Klick ohne Wischen, nicht auf Bild/Knoepfe) */
    var p0=null, tapZeit=0;
    lb.addEventListener("pointerdown",function(e){ if(e.pointerType==="mouse"&&e.button!==0){ p0=null; return; } p0={x:e.clientX,y:e.clientY,t:Date.now(),id:e.pointerId,ziel:e.target}; },{passive:true});
    lb.addEventListener("pointercancel",function(){ p0=null; },{passive:true});
    lb.addEventListener("pointerup",function(e){
      if(!p0||p0.id!==e.pointerId) return; var dx=e.clientX-p0.x, dy=e.clientY-p0.y, ziel=p0.ziel; p0=null;
      if(!zoom && Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.2 && liste.length>1){ zeigen(idx+(dx<0?1:-1)); return; }   /* Wischen */
      if(Math.abs(dx)>8||Math.abs(dy)>8) return;                                                                            /* bewegt = kein Klick */
      if(ziel===els.bild){
        if(e.pointerType==="mouse"){ zoomWechsel(e); return; }
        var jetzt=Date.now(); if(jetzt-tapZeit<320){ tapZeit=0; zoomWechsel(e); } else tapZeit=jetzt;                      /* Doppeltipp */
        return;
      }
      if(ziel===els.buehne||ziel===els.fuss) schliessen();
    },{passive:true});
    els.bild.addEventListener("keydown",function(e){ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); zoomWechsel(null); } });
    els.bild.addEventListener("load",function(){ if(els.bild.getAttribute("src")===els.bild.dataset.gross) lb.classList.remove("is-laedt"); });
    els.bild.addEventListener("error",function(){ lb.classList.remove("is-laedt"); });
  }
  function zoomWechsel(e){
    if(zoom){ zoomAus(); return; }
    var b=els.bild, st=els.buehne, r=b.getBoundingClientRect(); if(!r.width||!r.height) return;
    var cx=e?(e.clientX-r.left)/r.width:.5, cy=e?(e.clientY-r.top)/r.height:.5;
    zoom=true; lb.classList.add("is-zoom");
    b.style.width=Math.round(r.width*2)+"px"; b.style.height=Math.round(r.height*2)+"px";
    st.scrollLeft=Math.max(0,Math.round(12+r.width*2*cx-st.clientWidth/2));
    st.scrollTop=Math.max(0,Math.round(12+r.height*2*cy-st.clientHeight/2));
  }
  function zoomAus(){ if(!lb) return; zoom=false; lb.classList.remove("is-zoom"); els.bild.style.width=""; els.bild.style.height=""; els.buehne.scrollLeft=0; els.buehne.scrollTop=0; }
  function zeigen(i){
    if(!liste.length) return;
    i=(i%liste.length+liste.length)%liste.length; idx=i; var q=liste[i]; zoomAus();
    var nr=++ladeNr, klein=q.currentSrc||q.src, url=gross(q);
    els.bild.alt=q.alt||""; els.bild.dataset.gross=url;
    els.fuss.textContent=q.alt||"";
    var mehr=liste.length>1; els.l.hidden=!mehr; els.r.hidden=!mehr; els.zahl.hidden=!mehr; els.zahl.textContent=(i+1)+" / "+liste.length;
    if(url===klein){ lb.classList.remove("is-laedt"); els.bild.src=url; }
    else {
      els.bild.src=klein; lb.classList.add("is-laedt");                                /* sofort das schon geladene Bild, dann die grosse Fassung */
      var im=new Image(); im.onload=function(){ if(ladeNr!==nr) return; els.bild.src=url; };
      im.onerror=function(){ if(ladeNr===nr) lb.classList.remove("is-laedt"); }; im.src=url;
    }
    if(mehr){ [i+1,i-1].forEach(function(k){ var n=liste[(k%liste.length+liste.length)%liste.length]; var p=new Image(); p.src=gross(n); }); }
  }
  function fokusierbar(){ return [els.x,els.l,els.r,els.bild].filter(function(el){ return el&&!el.hidden&&el.offsetParent!==null; }); }
  function tasten(e){
    if(!offen) return;
    if(e.key==="Escape"){ e.preventDefault(); e.stopPropagation(); schliessen(); return; }
    if(e.key==="Tab"){ var f=fokusierbar(); if(!f.length) return; var a=document.activeElement, i=f.indexOf(a);
      if(e.shiftKey){ if(i<=0){ e.preventDefault(); f[f.length-1].focus(); } } else if(i===f.length-1||i<0){ e.preventDefault(); f[0].focus(); }
      e.stopPropagation(); return; }
    if(zoom) return;
    if(e.key==="ArrowRight"){ e.preventDefault(); e.stopPropagation(); zeigen(idx+1); }
    else if(e.key==="ArrowLeft"){ e.preventDefault(); e.stopPropagation(); zeigen(idx-1); }
  }
  function oeffnen(img){
    if(!img) return; if(!lb) bauen();
    liste=gruppe(img); var i=liste.indexOf(img); if(i<0){ liste=[img]; i=0; }
    ausloeser=document.activeElement; offen=true; lb.hidden=false;
    document.documentElement.classList.add("wl-lb-offen");
    if(reduziert) lb.classList.add("is-an"); else requestAnimationFrame(function(){ lb.classList.add("is-an"); });
    zeigen(i); document.addEventListener("keydown",tasten,true);
    try{ els.x.focus({preventScroll:true}); }catch(e){ els.x.focus(); }
  }
  function schliessen(){
    if(!offen) return; offen=false; document.removeEventListener("keydown",tasten,true);
    lb.classList.remove("is-an");
    var q=liste[idx];
    var fertig=function(){ lb.hidden=true; document.documentElement.classList.remove("wl-lb-offen"); zoomAus(); lb.classList.remove("is-laedt"); els.bild.removeAttribute("src"); };
    if(reduziert) fertig(); else setTimeout(fertig,190);
    /* Galerie auf das zuletzt betrachtete Bild stellen */
    try{ if(q&&q.closest("#wlpMain")&&window.wlpGoto){ var sl=q.closest(".wlp-slide"), k=$all("#wlpMain .wlp-slide").indexOf(sl); if(k>=0) window.wlpGoto(k); } }catch(e){}
    var a=ausloeser; ausloeser=null;
    if(a&&a.focus&&document.contains(a)){ try{ a.focus({preventScroll:true}); }catch(e){ a.focus(); } }
  }

  /* ---- Ausloeser auf der Seite: Klick/Tipp ohne Wischen ---- */
  var d0=null;
  document.addEventListener("pointerdown",function(e){ d0={x:e.clientX,y:e.clientY}; },{passive:true,capture:true});
  document.addEventListener("click",function(e){
    if(offen) return;
    var img=e.target&&e.target.closest&&e.target.closest(SEL); if(!img) return;
    if(e.target.closest(".wlp-pfeil,.wlp-badge,button,a")) return;
    if(d0&&(Math.abs(e.clientX-d0.x)>8||Math.abs(e.clientY-d0.y)>8)) return;   /* Galerie-Wischen (wl-produkt.js) bleibt Wischen */
    if(img.closest(".wlp-slide")&&!img.closest(".wlp-slide").classList.contains("is-on")) return;
    e.preventDefault(); oeffnen(img);
  });
  /* Tastatur: Enter/Leertaste auf der fokussierten Galerie oeffnet das aktuelle Bild */
  if(main) main.addEventListener("keydown",function(e){
    if(e.target!==main||(e.key!=="Enter"&&e.key!==" ")) return;
    var s=main.querySelector(".wlp-slide.is-on:not(.is-vorschau) img"); if(!s) return; e.preventDefault(); oeffnen(s);
  });
  window.wlLightbox={oeffnen:oeffnen,schliessen:schliessen,weiter:function(){ zeigen(idx+1); },zurueck:function(){ zeigen(idx-1); }};
})();
